import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  adornment: {
    marginRight: theme.spacing(5),
  },
  circularProgress: {
    color: theme.palette.neutral.light,
  },
}))

export default useStyles
